import { render, staticRenderFns } from "./EMLAttachment.vue?vue&type=template&id=244005a6&scoped=true"
import script from "./EMLAttachment.vue?vue&type=script&lang=js"
export * from "./EMLAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244005a6",
  null
  
)

export default component.exports